/**
 * Primaire lokale zoekwoorden voor Nederlandse locatiepagina's.
 *
 * Het primaire zoekwoord van een plaats- of gemeentepagina is altijd
 * "taxi <naam>", in de officiële Nederlandse schrijfwijze van die naam
 * (hoofdletters, koppeltekens, apostroffen en spaties ongewijzigd).
 * Het woord "gemeente" hoort niet in het zoekwoord.
 */

/** "taxi Hoek van Holland", "taxi 's-Gravendeel", "taxi Hoeksche Waard". */
export function primaryKeyword(name: string): string {
  return `taxi ${name.replace(/^Gemeente\s+/i, "").trim()}`;
}

function escapeRegex(input: string) {
  return input.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * Staat het zoekwoord als losse woordgroep in de tekst? "Luchthaventaxi
 * Brielle" telt dus niet als "taxi Brielle", "Taxi Brielle nodig?" wel.
 */
export function hasPrimaryKeyword(text: string, keyword: string): boolean {
  const [, ...rest] = keyword.split(/\s+/);
  const name = rest.join(" ");
  const re = new RegExp(
    `(^|[^\\p{L}])taxi\\s+${escapeRegex(name)}($|[^\\p{L}])`,
    "iu",
  );
  return re.test(text);
}
